/* import __COLOCATED_TEMPLATE__ from './popup-menu.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
import TEMPLATE from "./popup-menu.hbs";
export default setComponentTemplate(TEMPLATE, Component.extend({}));